import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { HUD } from "./hud/HUD";
import { CursorController } from "./CursorController";
import { MazeContainer } from "./MazeContainer";
import { MazeManager } from "./MazeManager";
import { GameOverLayer } from "./GameOverLayer";
import { GUI } from "./GUI";
import { PauseLayer } from "./PauseLayer";
import { GameVars } from "../../GameVars";
import { TransitionLayer } from "./TransitionLayer";
import { BootScene } from "../BootScene";
import { AudioManager } from "../../AudioManager";

export class MazeScene extends Phaser.Scene {

    public static currentInstance: MazeScene;

    public hud: HUD;
    public gui: GUI;

    private cursorController: CursorController;
    private mazesContainer: Phaser.GameObjects.Container;
    private mazeContainer: MazeContainer;
    private gameOverLayer: GameOverLayer;
    private pauseLayer: PauseLayer;
    private transitionLayer: TransitionLayer;
    private darkLayer: Phaser.GameObjects.Graphics;

    constructor() {

        super("MazeScene");
    }

    public create(): void {

        MazeScene.currentInstance = this;

        GameManager.setCurrentScene(this);

        this.gameOverLayer = null;
        this.pauseLayer = null;
        this.cursorController = new CursorController(this);

        const tmpBackground = this.add.graphics();
        tmpBackground.fillStyle(0x131538);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        this.mazesContainer = this.add.container(0, 0);

        this.mazeContainer = null;

        this.darkLayer = this.add.graphics();
        this.darkLayer.fillStyle(0x131531);
        this.darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.darkLayer.alpha = 0;
        this.darkLayer.visible = false;

        this.hud = new HUD(this);
        this.add.existing(this.hud);

        this.gui = new GUI(this);
        this.add.existing(this.gui);

        MazeManager.init();

        this.cameras.main.fadeIn(150, 19, 21, 54);
    }

    public update(time: number, delta: number): void {

        super.update(time, delta);

        this.cursorController.update();

        BootScene.staticUpdate();
    }

    public newLevel(): void {

        if (this.mazeContainer) {
            this.mazeContainer.destroy();
        }

        switch (GameVars.currentLevel) {

            case 1:
                AudioManager.playSound("loop_1", true);
                break;
            case 2:
                AudioManager.playSound("loop_2", true);
                break;
            case 3:
                AudioManager.playSound("loop_3", true);
                break;
            case 4:
                AudioManager.playSound("loop_4", true);
                break;
            case 5:
                AudioManager.playSound("loop_5", true);
                break;
            case 6:
                AudioManager.playSound("loop_6", true);
                break;
            case 7:
                AudioManager.playSound("loop_7", true);
                break;
            default:
                AudioManager.increaseLoopRate();
                break;
        }

        this.hud.updateLevel();

        this.mazeContainer = new MazeContainer(this);
        this.mazesContainer.add(this.mazeContainer);


        if (GameVars.currentLevel > 1) {

            this.mazeContainer.visible = false;

            this.darkLayer.visible = true;

            this.tweens.add({
                targets: this.darkLayer,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 200,
                onComplete: function(): void {
                    
                    this.mazeContainer.visible = true;

                    this.tweens.add({
                        targets: this.darkLayer,
                        alpha: 0,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 200,
                        onComplete: function(): void {
                            this.darkLayer.visible = false;
                        },
                        onCompleteScope: this
                    });
                },
                onCompleteScope: this
            });
        }       
    }

    public invalidDirection(): void {

        AudioManager.playSound("wrong_direction_input");
    }

    public gameOver(): void {

        this.mazeContainer.gameOver();

        this.cameras.main.shake(100, 0.025);

        this.gui.visible = false;

        this.gameOverLayer = new GameOverLayer(this);
        this.add.existing(this.gameOverLayer);

        AudioManager.playSound("gameover_loop", true);
    }

    public showPauseLayer(): void {

        MazeContainer.currentInstance.bringGridToFront();

        this.gui.paused();

        this.pauseLayer = new PauseLayer(this);
        this.add.existing(this.pauseLayer);

        AudioManager.setLoopVolume(.25);
    }

    public hidePauseLayer(): void {

        MazeContainer.currentInstance.sendGridToBack();

        this.gui.resumed();

        if (this.pauseLayer) {
            this.pauseLayer.destroy();
        }

        AudioManager.setLoopVolume(1);
    }

    public showTransitionLayer(f: Function): void {

        GameVars.pause = true;

        this.gui.visible = false;

        this.transitionLayer = new TransitionLayer(this, f);
        this.add.existing(this.transitionLayer);
    }

    public hideTransitionLayer(): void {

        GameVars.pause = false;

        this.gui.visible = true;

        if (this.transitionLayer) {
            this.transitionLayer.destroy();
        }
    }

    public onExtraTime(): void {

        this.hud.extraTime(GameConstants.POWER_UP_EXTRA_TIME);
        this.mazeContainer.extraTime();

        AudioManager.playSound("add_time_bonus");
    }

    public mazeSolved(): void {

        this.mazeContainer.mazeSolved();

        const goalState = MazeContainer.currentInstance.goal.currentState;

        if (goalState === GameConstants.GOAL_POINTS) {
            this.hud.extraPoints();
            AudioManager.playSound("outro_added_score");
        } else if (goalState === GameConstants.GOAL_TIME) {
            this.hud.extraTime(GameConstants.PASSED_LEVEL_EXTRA_TIME);
            AudioManager.playSound("outro_added_time");
        } else {
            AudioManager.playSound("outro_no_effect");
        }
    }
}
